import { Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { Location } from '@angular/common';
import { BootstrapMarketoService } from 'lib/services/bootstrap/bootstrap-marketo.service';
import { RouterService } from 'lib/services/router.service';
import { WebpService } from 'lib/services/webp.service';
import { CategoryService } from 'lib/services/category/category.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { CmsService } from 'lib/services/cms.service';
import { ExxAccordionImageAndTextComponent } from '../../../../../components/accordion-image-and-text/accordion-image-and-text.component';
@Component({
    selector: 'cms-partial-category-top-component-accordion',
    templateUrl: './accordion.component.html',
    standalone: true,
    imports: [CommonModule, ExxAccordionImageAndTextComponent],
})
export class AccordionComponent extends CmsPartialComponentClass {
    @Input() accordionRow: any;
    @Input() uniqueIndex: number;
    @Input() dataUrl: string;
    @Input() dataTitle: string;
    @Input() solutionID: string;
    @Input() grayBackgroundRows: any = [];

    @ViewChild('buttonRowImageElement') buttonRowImageElement: ElementRef;
    activeButtonId: string = '';
    currentButtonRowImage: string = '';
    currentButtonRowImageAlt: string = '';

    getWebpImg: (src: string) => string;

    constructor(
        @Inject('environment') environment: any,
        breakpointObserver: BreakpointObserver,
        public bootstrapMarketoService: BootstrapMarketoService,
        cmsService: CmsService,
        routerService: RouterService,
        webpService: WebpService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                bootstrapMarketoService,
                breakpointObserver,
                cmsService,
                environment,
                routerService,
                location,
                categoryService,
                webpService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }
}
